import {
  Box,
  CircularProgress,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { useEffect } from 'react'
import { useAppDispatch } from 'store/hooks'
import { actions as reportingBenchmarkActions } from 'store/reporting/benchmark'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

type Props = {
  userId: string
}

export default function BenchmarksTable({ userId }: Props) {
  const id = userId
  const dispatch = useAppDispatch()
  const data = useSelector((state: RootState) => state.reportingBenchmark.benchmarks)
  const isLoading = useSelector((state: RootState) => state.reportingBenchmark.loading.benchmarks)
  const error = useSelector((state: RootState) => state.reportingBenchmark.error.benchmarks)

  useEffect(() => {
    if (id) dispatch(reportingBenchmarkActions.fetchBenchmarks(id))
  }, [dispatch, id])

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 450 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Ipcr codes</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Origin</TableCell>
            <TableCell>Params</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.map(row => (
              <TableRow hover>
                <TableCell>
                  <Link href={`/dashboard/reporting/benchmark/${row.id}`} target="_blank" style={{ display: 'flex', gap: 4 }}>
                    <Box mt={0.2}>{row.name}</Box> <OpenInNewIcon sx={{ fontSize: 13 }} />
                  </Link>
                </TableCell>
                <TableCell>{row.ipcrCodes.join(', ')}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.origin}</TableCell>
                <TableCell>{JSON.stringify(row.params).split(',').join(', ')}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {data && data?.length === 0 && <Stack p={2}>No benchmark reports created</Stack>}
      <Box sx={{ textAlign: 'center', width: 1 }}>
        {isLoading && <CircularProgress />}
        {error && (
          <Typography p={1} color={'red'}>
            {error}
          </Typography>
        )}
      </Box>
    </TableContainer>
  )
}
